import { render, staticRenderFns } from "./searchLiteraturePage.vue?vue&type=template&id=3113aa57&scoped=true&"
import script from "./searchLiteraturePage.vue?vue&type=script&lang=js&"
export * from "./searchLiteraturePage.vue?vue&type=script&lang=js&"
import style0 from "./searchLiteraturePage.vue?vue&type=style&index=0&id=3113aa57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3113aa57",
  null
  
)

export default component.exports